'use client';

import React from 'react';
import { useStore } from '@/store/store';
import { getText } from '@/utils/text/text';
import { POPUPS } from '@/app/components/popup/constants';
import { VolatilityLowIcon } from '@/app/elements/svg/icons/volatility-low';
import { VolatilityMediumIcon } from '@/app/elements/svg/icons/volatility-medium';
import { VolatilityHighIcon } from '@/app/elements/svg/icons/volatility-high';

import './styles/default.scss';

const volatilityOptions = [
    {
        icon: VolatilityLowIcon,
        iconAlt: 'Low volatility',
        label: 'components.volatilityInfoModal.lowVolatilityLabel',
        description: 'components.volatilityInfoModal.lowVolatilityDescription'
    },
    {
        icon: VolatilityMediumIcon,
        iconAlt: 'Med volatility',
        label: 'components.volatilityInfoModal.medVolatilityLabel',
        description: 'components.volatilityInfoModal.medVolatilityDescription'
    },
    {
        icon: VolatilityHighIcon,
        iconAlt: 'High volatility',
        label: 'components.volatilityInfoModal.highVolatilityLabel',
        description: 'components.volatilityInfoModal.highVolatilityDescription'
    }
];

export const VolatilityInfoPopup: React.FC = () => {
    const { activePopup, closePopup } = useStore((s) => s.popup);

    if (activePopup?.type !== POPUPS.VOLATILITY_INFO) {
        return null;
    }

    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) {
            closePopup();
        }
    };

    return (
        <div className="volatility-modal-overlay" onClick={handleOverlayClick} role="dialog" aria-modal="true">
            <div className="volatility-modal">
                <button
                    onClick={closePopup}
                    className="volatility-modal__close-icon-btn"
                    aria-label="Close modal"
                    type="button">
                    <img
                        src="/images/icon-close-white-thin.svg"
                        className="volatility-modal__close-icon"
                        alt="close icon"
                    />
                </button>

                <div className="volatility-modal__header-wrapper">
                    <div className="volatility-modal__header-ellipse" />
                    <img src="/images/casino101.png" alt="Casino 101" className="volatility-modal__logo" />
                </div>

                <div className="volatility-modal__content">
                    <h2 className="volatility-modal__title">
                        {getText({ text: 'components.volatilityInfoModal.title' })}
                    </h2>
                    <p className="volatility-modal__description">
                        {getText({ text: 'components.volatilityInfoModal.description' })}
                    </p>

                    <div className="volatility-modal__options">
                        {volatilityOptions.map((option) => (
                            <div key={option.label} className="volatility-modal__option volatility-modal__option-text">
                                <span className="volatility-modal__option-icon">
                                    <option.icon fill="#0a0a0a" aria-label={option.iconAlt} />
                                </span>
                                <div>
                                    <span className="option-label">{getText({ text: option.label })}</span>
                                    <p className="volatility-modal__option-description">
                                        {getText({ text: option.description })}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <button className="volatility-modal__close-btn" onClick={closePopup} type="button">
                        {getText({ text: 'common.close' })}
                    </button>
                </div>
            </div>
        </div>
    );
};
